export default function FerryDashboard(){
    return <>
        <div className="dashboard-content">
            <h1>Ferry Dashboard</h1>
        </div>
    </>
}